export default {"src":"/_next/static/media/google-play-badge-nl.99ffc8d4.svg","height":54,"width":180,"blurWidth":0,"blurHeight":0};